<template>
  <animated-button
    buttonClass="btn link-button w-auto d-inline-block"
    icon="fa-clipboard t-sm"
    animatedIcon="fa-check t-green t-sm"
    title="Copy to clipboard"
    @click.stop="onCopy" />
</template>

<script>
/**
 * Shows up as a copy-icon. On click, the `text`-property is copied to the clipboard.
 * Example usage: <copy-icon :text="Hello world" />
 *
 * TODO - further refinements:
 * - Replace all uses of v-clipboard with this (we'll need to replace that anyway when switching to Vue 3)
 * - Maybe catch any errors of clipboard.writeText (but doesn't really occur in practice)
 */

import AnimatedButton from '@/components/shared/AnimatedButton'

export default {
  name: 'CopyIcon',
  components: {
    AnimatedButton
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    onCopy () {
      navigator.clipboard.writeText(this.text)
    }
  }
}
</script>
